import settings from './settings.js';
import globals from './globals.js';
import store from './store.js';

import "./assets/favicon.png"
import "./assets/logo.png"

import axios from 'axios';
import Vue from 'vue';
// import { io } from "socket.io-client";
// const socket = io("http://localhost:3000");
// socket.emit('chat message', {val:'3333',d:1});

import VueRouter from 'vue-router';
import VueSelect from 'vue-select'
import '../../node_modules/vue-select/dist/vue-select.css'
import dataList from './components/admin/dataList.vue';

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import App from './app.vue';

import appRootClient from './app-client.vue';
import clientHome from './views/client/home.vue';
import article from './views/client/article.vue';

import appRootAdmin from './app-server.vue';
import adminHome from './views/admin/home.vue';
import login from './views/admin/login.vue';
import sections from './views/admin/sections.vue';
import section from './views/admin/section.vue';

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo)

Vue.use(VueRouter);
Vue.component('vue-select',VueSelect);
Vue.component("data-list", dataList)

const routes=[
  { path: '/', component: appRootClient, props: true,children:[
    {path:'', component:clientHome},
    {path:'articles/:id', component:article, props: true}
  ]},
  {
    path:'/admin',component:appRootAdmin,props:true,children:[
      {path:'', component:adminHome,props: true,meta:{auth:false} },
      {path:'signin', component:login,props: true,meta:{auth:false} },
      {path: 'articles', component: sections, props: true,meta:{auth:true} },
      {path: 'articles/:id', component: section, props: true,meta:{auth:true} },
    ]
  }
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  let token=globals.getToken();
  if (!to.meta.auth) {
    if (!store.state.user && token && to.fullPath!='/admin/signin'){
      let r=await axios.post(`${settings.authServiceUrl}token/getUserFromToken`, { tokenValue: token });
      if (r.data.code!=-1001){
        let u=r.data.payload;
        //r=await axios.post(`${settings.userServiceUrl}user/getMany`, {item:{authId:u.id}, tokenValue: token });
        //u.info=r.data.payload.items[0];
        store.commit('setUser',u);
      }
    }
    next();
    return;
  }
  
  if (!token){
    next('/admin/signin');
    return;
  }
  let r=await axios.post(`${settings.authServiceUrl}token/tokenExpired`, { tokenValue: token });
  if (r.data.code <0) {
    globals.removeToken();
    next('/admin/signin');
    return;
  }
  if (!store.state.user){
    let r=await axios.post(`${settings.authServiceUrl}token/getUserFromToken`, { tokenValue: token });
      if (r.data.code!=-1001)
        store.commit('setUser',r.data.payload);
  }
  next();
});

let app=new Vue({
  el: '#app',
  render: h => h(App),
  components: { App },
  router,
  store,
  data: {},
  mounted() {
    Metro.init();
  },
  methods: {
  },
});

axios.interceptors.response.use(function (response) {
  if (response.data.code===-1001 || response.data.code===-1){ //No token found in database
    globals.removeToken();
    app.$store.commit('setUser',undefined);
    app.$router.push('/admin/signin');
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});